import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
} from './integrationImport';

export const connectSageHR = async (companyId, userId, subdomain, apiKey) => {
  const { data } = await httpClient.post('/sageHRConnect', {
    companyId,
    userId,
    subdomain,
    apiKey,
  });
  return data;
};

export const disconnectSageHR = async (companyId, userId) => {
  const { data } = await httpClient.post('/sageHRDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getSageHREmployees = async (companyId) => {
  const { data } = await httpClient.post('/sageHRGetEmployees', { companyId });
  return data;
};

export const autoMapSageHREmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/sageHRAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const saveSageHRMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/sageHRSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncSageHRTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/sageHRSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const exportAllSageHREmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/sageHRExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const previewSageHRImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/sageHRPreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const importSageHREmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/sageHRImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToSageHRImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'sagehr', onUpdate);

export const getSageHRImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'sagehr', logId);

export const subscribeToSageHRStatus = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc('sagehr')
    .onSnapshot(
      (doc) => {
        if (!doc.exists || !doc.data().connected) {
          onUpdate({
            connected: false,
            subdomain: null,
            connectedAt: null,
            connectedBy: null,
            employeeMappings: {},
            employeeMappingsUpdatedAt: null,
            lastSyncAt: null,
            lastSyncStats: null,
          });
          return;
        }
        const d = doc.data();
        onUpdate({
          connected: true,
          subdomain: d.subdomain || null,
          connectedAt: d.connectedAt?.toDate?.() ?? null,
          connectedBy: d.connectedBy || null,
          employeeMappings: d.employeeMappings || {},
          employeeMappingsUpdatedAt:
            d.employeeMappingsUpdatedAt?.toDate?.() ?? null,
          lastSyncAt: d.lastSyncAt?.toDate?.() ?? null,
          lastSyncStats: d.lastSyncStats || null,
        });
      },
      (err) => {
        console.error('Sage HR status listener error:', err);
        onUpdate({
          connected: false,
          subdomain: null,
          connectedAt: null,
          connectedBy: null,
          employeeMappings: {},
          employeeMappingsUpdatedAt: null,
          lastSyncAt: null,
          lastSyncStats: null,
        });
      }
    );
};
